import { apiSlice } from "./apiSlice";
import { ENDPOINTS } from "../../shared/constants/urls";

export const paymentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentSubscription: builder.query({
      query: () => ({
        url: `${ENDPOINTS.CURRENT_SUBSCRIPTION}`,
        method: "GET",
      }),
      extraOptions: { requiresAuth: true },
    }),
    changeSubscription: builder.mutation({
      query: ({ new_plan_id }) => ({
        url: `${ENDPOINTS.CHANGE_SUBSCRIPTION}?new_plan_id=${new_plan_id}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    createSetupIntent: builder.query({
      query: () => ({
        url: `${ENDPOINTS.CREATE_SETUP_INTENT}`,
        method: "GET",
      }),
      extraOptions: { requiresAuth: true },
    }),
    cancelSubscription: builder.mutation({
      query: () => ({
        url: `${ENDPOINTS.CANCEL_SUBSCRIPTION}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    restartSubscription: builder.mutation({
      query: () => ({
        url: `${ENDPOINTS.RESTART_SUBSCRIPTION}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    getPaymentHistory: builder.query({
      query: () => ({
        url: `${ENDPOINTS.PAYMENT_HISTORY}`,
        method: "GET",
      }),
      extraOptions: { requiresAuth: true },
    }),
    getPaymentMethods: builder.query({
      query: () => ({
        url: `${ENDPOINTS.PAYMENT_METHODS}s`,
        method: "GET",
      }),
      extraOptions: { requiresAuth: true },
    }),
    updateDefaultPaymentMethod: builder.mutation({
      query: ({ payment_method_id }) => ({
        url: `${ENDPOINTS.PAYMENT_METHODS}/update-default?payment_method_id=${payment_method_id}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    deletePaymentMethod: builder.mutation({
      query: ({ payment_method_id }) => ({
        url: `${ENDPOINTS.PAYMENT_METHODS}/delete?payment_method_id=${payment_method_id}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    addPaymentMethod: builder.mutation({
      query: ({ setup_intent_id }) => ({
        url: `${ENDPOINTS.PAYMENT_METHODS}/add?setup_intent_id=${setup_intent_id}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    purchaseTokens: builder.mutation({
      query: ({ pack_type }) => ({
        url: `${ENDPOINTS.SEO_TOKENs}?pack_type=${pack_type}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    confirmTokenPurchase: builder.mutation({
      query: ({ session_id }) => ({
        url: `${ENDPOINTS.CONFIRM_TOKEN_PURCHASE}?session_id=${session_id}`,
        method: "POST",
      }),
      extraOptions: { requiresAuth: true },
    }),
    endTrial: builder.query({
      query: () => ({
        url: `${ENDPOINTS.END_TRIAL}`,
        method: "GET",
      }),
      extraOptions: { requiresAuth: true },
    }),
  }),
});

export const {
  useGetCurrentSubscriptionQuery,
  useLazyGetCurrentSubscriptionQuery,
  useChangeSubscriptionMutation,
  useCreateSetupIntentQuery,
  useCancelSubscriptionMutation,
  useRestartSubscriptionMutation,
  useGetPaymentHistoryQuery,
  useGetPaymentMethodsQuery,
  useAddPaymentMethodMutation,
  useDeletePaymentMethodMutation,
  useUpdateDefaultPaymentMethodMutation,
  usePurchaseTokensMutation,
  useConfirmTokenPurchaseMutation,
  useEndTrialQuery,
  useLazyEndTrialQuery,
} = paymentApiSlice;
